import { defineComponent as _defineComponent } from 'vue'
import VButton from '../../common/components/VButton.vue';
import FormElement from './FormElement.vue';
import { FormModel, FormEvent, FormAction } from '../interfaces/form';
import { PropType, reactive, watch, ref } from 'vue';
import { FormValidation } from '../interfaces';
import { useFormElement } from '../composables/useFormElement';
import { makeUseFormElementEmits } from '../composables/useFormElementInterfaces';
/**
 * Dynamic Form component
 *
 * Usually the base component for any schema based forms
 * Emits:
 * - `form-event` for all form events (re-emited from fields or emited from form actions)
 * - `submit` - convenience event, emmited alongside the relevant `form-event`
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'DynamicForm',
  props: {
  form: {
    type: Object as PropType<FormValidation<FormModel>>,
    required: true,
  },
},
  emits: {
  ...makeUseFormElementEmits(),
  submit: (_event: FormEvent) => true,
},
  setup(__props, { expose, emit }) {

const props = __props;





const formElProps = reactive({
  field: props.form,
  model: props.form.$model,
});

const fieldEls = ref<InstanceType<typeof FormElement>[]>([]);

watch(
  () => props.form,
  () => {
    formElProps.field = props.form as any;
    formElProps.model = props.form.$model;
  }
);

const { modelStateRef, model, field } = useFormElement({
  emit,
  props: formElProps,
});

const requiredText = modelStateRef('requiredText', '');

const requiredTextNote = modelStateRef('requiredTextNote', '');

const formClass = modelStateRef('formClass', 'form dynamic-form', true);

function onFormEvent(event: FormEvent) {
  emit('form-event', event);
  if (event.event === 'form-field-submit') {
    emit('submit', event);
  }
}

function onFormAction(action: FormAction) {
  setTimeout(() => {
    emit('form-event', {
      field: field.value,
      model: model.value as FormModel,
      event: 'form-action',
      action,
    } as FormEvent);
  });
}

function triggerFieldAction(path: string, action: any) {
  if (model.value.$path === path) {
    // trigger action here!
  } else {
    model.value.$fields.forEach((field: any, index: number) => {
      if (path.startsWith(field.$path)) {
        const child = fieldEls.value[index] as InstanceType<typeof FormElement>;
        if (child && child.triggerFieldAction) {
          child.triggerFieldAction(path, action);
        }
      }
    });
  }
}

expose({
  triggerFieldAction,
});

return { __sfc: true,props, emit, formElProps, fieldEls, modelStateRef, model, field, requiredText, requiredTextNote, formClass, onFormEvent, onFormAction, triggerFieldAction, VButton, FormElement }
}

})